export default __webpack_public_path__ + "static/media/11.50520904.jpg";